<template>
	<div class="project-modify-phases-loader">
		<div class="project-modify-phases-loader__row">
			<SuiSkeleton width="30%" height="1.5rem" />
			<div />
			<SuiSkeleton width="74%" height="1.5rem" />
			<SuiSkeleton width="74%" height="1.5rem" />
		</div>
		<div class="project-modify-phases-loader__row">
			<SuiSkeleton width="100%" height="3.875rem" />
			<div />
			<SuiSkeleton width="92%" height="3.875rem" />
			<SuiSkeleton width="92%" height="3.875rem" />
		</div>
		<div class="project-modify-phases-loader__row">
			<SuiSkeleton width="100%" height="3.875rem" />
			<div />
			<SuiSkeleton width="92%" height="3.875rem" />
			<SuiSkeleton width="92%" height="3.875rem" />
		</div>
		<div class="project-modify-phases-loader__row">
			<SuiSkeleton width="100%" height="3.875rem" />
			<div />
			<SuiSkeleton width="92%" height="3.875rem" />
			<SuiSkeleton width="92%" height="3.875rem" />
		</div>
	</div>
</template>
<script setup lang="ts">
import { SuiSkeleton } from '@developers/scoro-ui';
</script>

<style lang="scss" scoped>
.project-modify-phases-loader {
	width: 100%;
	border-collapse: collapse;

	&__row {
		display: grid;
		grid-template-columns: 30rem auto 13rem 13rem;
		border-bottom: 1px solid $neutral-30;
		white-space: nowrap;
		padding: 2rem 1rem 2rem 4rem;

		&:not(:first-of-type) > * {
			border-radius: 0.5rem;
		}
	}
}
</style>
